import React from 'react'
import { Badge, MantineColor } from '@mantine/core'
import { useAppTranslation } from 'hooks/useTranslation'

type CampaignStatus = 'Draft' | 'Scheduled' | 'Active' | 'Paused' | 'Ended'

interface CampaignStatusBadgeProps {
  status: CampaignStatus
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const statusConfig: Record<CampaignStatus, { color: MantineColor; translationKey: string }> = {
  'Draft': { color: 'gray', translationKey: 'campaigns.status_draft' },
  'Scheduled': { color: 'blue', translationKey: 'campaigns.status_scheduled' },
  'Active': { color: 'green', translationKey: 'campaigns.status_active' },
  'Paused': { color: 'yellow', translationKey: 'campaigns.status_paused' },
  'Ended': { color: 'red', translationKey: 'campaigns.status_ended' }
}

export const CampaignStatusBadge: React.FC<CampaignStatusBadgeProps> = ({
  status,
  size = 'sm'
}) => {
  const { t } = useAppTranslation()
  const config = statusConfig[status]

  return (
    <Badge color={config.color} size={size} variant='filled'>
      {t(config.translationKey)}
    </Badge>
  )
}